export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8159.a85cc665.jpg";